import type { AssistantAnswerMessage } from '@/entities/discovery';
import { AssistantMessageRow } from './primitives';

export const AssistantMessageAnswer = ({ message }: { message: AssistantAnswerMessage }) => {
  return (
    <AssistantMessageRow>
      <div className="mt-1 flex flex-1 flex-col gap-3">
        <span className="text-primary text-sm">{message.content.message}</span>
      </div>
    </AssistantMessageRow>
  );
};
